import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AdminTemplate from "../../../components/admin/layouts/Template.js";
import ContentWrapper from "../../../components/common/AssessmentContentWrapper.js";
import ManagePassageTypes from "./ManagePassageTypes.js";
import ManagePassages from "./ManagePassages.js";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let tabTextColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    tabTextColor = "var(--maincolor)";
    break;
  case customerConstants.EXO_CUSTOMER2:
    tabTextColor = "var(--maincolor-cmc)";
    break;
  default:
    tabTextColor = "var(--maincolor)";
    break;
}

class Passage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
    };
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  renderTabs() {
    return [
      { label: "Passage-Types", index: 0 },
      { label: "Passages", index: 1 },
    ];
  }

  renderTabPanels() {
    const { value } = this.state;
    const panels = [<ManagePassageTypes />, <ManagePassages />];

    return panels.map((panel, index) => (
      <TabPanel value={value} index={index} key={index}>
        {panel}
      </TabPanel>
    ));
  }

  render() {
    const { value } = this.state;
    const tabs = this.renderTabs();

    return (
      <AdminTemplate>
        <ContentWrapper>
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: "background.paper",
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >
            {/* Top-side Tabs */}
            <Tabs
              value={value}
              onChange={this.handleChange}
              variant="scrollable"
              scrollButtons="auto"
              orientation="horizontal"
              aria-label="Passage top tabs"
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                "& .MuiTab-root": {
                  fontFamily: "Poppins, sans-serif",
                  textTransform: "unset",
                  letterSpacing: "-0.4px",
                  fontWeight: "600",
                },
                "& .Mui-selected, & .Mui-selected.MuiTab-root": {
                  color: `${tabTextColor} !important`,
                },
              }}
              TabIndicatorProps={{
                style: {
                  backgroundColor: tabTextColor,
                },
              }}
            >
              {tabs.map((tab) => (
                <Tab key={tab.index} label={tab.label} {...a11yProps(tab.index)} />
              ))}
            </Tabs>

            {/* Tab Panels */}
            {this.renderTabPanels()}
          </Box>
        </ContentWrapper>
      </AdminTemplate>
    );
  }
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

export default Passage;
